import { LaneAggregationsRequestModel } from "api/lokiRequestModels/lane/LaneAggregationsRequestModel";
import { LaneAggregationsList } from "models/laneAggregations/LaneAggregationsList";
import { LaneDetailsList } from "models/laneDetails/LaneDetailsList";
import { ProductExcursionsList } from "models/laneExcursion/ProductExcursionsList";
import { LaneStatistics } from "models/LaneStatistics";
import { LaneTempStatistics } from "models/LaneTempStatistics";
import { LaneTempProfileList } from "models/laneTempProfile/LaneTempProfileList";
import { LanesDetailsRequestModel } from "api/lokiRequestModels/lane/LanesDetailsRequestModel";
import { TempExcursionAggregationRequestModel } from "api/lokiRequestModels/lane/TempExcursionAggregationRequestModel";
import { LaneTripStatisticsRequestModel } from "api/lokiRequestModels/lane/LaneTripStatisticsRequestModel";
import { LaneTemperatureStatisticsRequestModel } from "api/lokiRequestModels/lane/LaneTemperatureStatisticsRequestModel";
import { LaneTemperatureProfileRequestModel } from "api/lokiRequestModels/lane/LaneTemperatureProfileRequestModel";
import { config } from "api/apiRoutes";
import { CommonRequestParameters } from "api/lokiRequestModels/CommonRequestParameters";
import { ListLaneMapDetails } from "models/laneMapDetails/ListLaneMapDetails";
import { lokiAxios } from "api/serviceConfig";

export class LaneService {
    // Lynx Dashboard - Global View page APIs
    // 1
    async getLaneAggregations(data: LaneAggregationsRequestModel) {
        const result = await lokiAxios.get<LaneAggregationsList>(
            config.aggregationsUrl,
            {
                params: {
                    startTime: data.startTime,
                    endTime: data.endTime,
                    customerId: data.customerId,
                    lsp: data.lsp,
                    productType: data.productType,
                    riskLevel: data.riskLevel, // change
                    transportationModes: data.transportationModes, // change
                    packagingType: data.packagingType,
                },
            }
        );

        return result;
    }

    // 2
    async listLanesDetails(data: LanesDetailsRequestModel) {
        return await lokiAxios.get<LaneDetailsList>(config.lanesInfoUrl, {
            params: {
                startTime: data.startTime,
                endTime: data.endTime,
                customerId: data.customerId,
                lsp: data.lsp,
                productType: data.productType,
                riskLevel: data.riskLevel, // change
                transportationModes: data.transportationModes, // change
                packagingType: data.packagingType,
                nextToken: data.nextToken,
                sort: data.sort,
                direction: data.direction,
            },
        });
    }

    // 3
    async getTempExcursionAggregation(
        data: TempExcursionAggregationRequestModel
    ) {
        return await lokiAxios.get<ProductExcursionsList>(config.lanesTempUrl, {
            params: {
                startTime: data.startTime,
                endTime: data.endTime,
                customerId: data.customerId,
                lsp: data.lsp,
                productType: data.productType,
                riskLevel: data.riskLevel, // change
                transportationModes: data.transportationModes, // change
                packagingType: data.packagingType,
            },
        });
    }

    // Lynx Dashboard - Global View → Lane APIs

    // 1
    async getLaneTripStatistics(data: LaneTripStatisticsRequestModel) {
        return await lokiAxios.get<LaneStatistics>(
            config.laneTripStatisticsUrl(data.laneId),
            {
                params: {
                    startTime: data.startTime,
                    endTime: data.endTime,
                    customerId: data.customerId,
                    lsp: data.lsp,
                    productType: data.productType,
                    riskLevel: data.riskLevel, // change
                    transportationModes: data.transportationModes, // change
                    packagingType: data.packagingType,
                },
            }
        );
    }

    // 2
    async getLaneTemperatureStatistics(
        data: LaneTemperatureStatisticsRequestModel
    ) {
        return await lokiAxios.get<LaneTempStatistics>(
            config.laneTemperatureStatisticsUrl(data.laneId),
            {
                params: {
                    startTime: data.startTime,
                    endTime: data.endTime,
                    customerId: data.customerId,
                    lsp: data.lsp,
                    productType: data.productType,
                    riskLevel: data.riskLevel, // change
                    transportationModes: data.transportationModes, // change
                    packagingType: data.packagingType,
                },
            }
        );
    }

    // 3
    async getLaneTemperatureProfile(data: LaneTemperatureProfileRequestModel) {
        return await lokiAxios.get<LaneTempProfileList>(
            config.laneTemperatureProfile(data.laneId),
            {
                params: {
                    startTime: data.startTime,
                    endTime: data.endTime,
                    customerId: data.customerId,
                    lsp: data.lsp,
                    productType: data.productType,
                    riskLevel: data.riskLevel, // change
                    transportationModes: data.transportationModes, // change
                    packagingType: data.packagingType,
                },
            }
        );
    }

    async getListMapDetails(data: CommonRequestParameters) {
        return await lokiAxios.get<ListLaneMapDetails>(config.mapDetailsUrl, {
            params: {
                startTime: data.startTime,
                endTime: data.endTime,
                customerId: data.customerId,
                lsp: data.lsp,
                productType: data.productType,
                riskLevel: data.riskLevel, // change
                transportationModes: data.transportationModes, // change
                packagingType: data.packagingType,
            },
        });
    }
}
